import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ContentType } from '../story/models/content-type.enum';
import { Platform } from '@angular/cdk/platform';
import { ContentViewsModel } from '../auth/models/content-views.model';

enum AppProductTypeEnum {
  Web = 'web',
  Android = 'mobile_android',
  iOS = 'mobile_ios'
}

interface TrackRequest {
  // product type (i.e., web vs ios vs android)
  app_producttype: AppProductTypeEnum;
  // key specific to product type
  app_productkey: string;
  // content params (note: 'bookmark' | 'module')
  content_type: ContentType;
  content_id: string;
  // optional: UTC timestamp
  event_timestamp?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContentViewService {

  constructor(
    private http: HttpClient,
    private platform: Platform) {
  }

  trackContentView(contentId: string, contentType: ContentType): Observable<any> {
    // static params
    const productType: AppProductTypeEnum = this.getProductType();

    return this.http.post('/ws/user/analytics/content/inapp/view', <TrackRequest>{
      app_producttype: productType,
      app_productkey: environment.productKey,
      content_type: contentType,
      content_id: contentId
    });
  }

  checkContentView(): Observable<ContentViewsModel> {
    return this.http.get<ContentViewsModel>('/ws/user/content/inapp/view/check');
  }

  getProductType(): AppProductTypeEnum {
    // check native platforms
    if (environment.native) {
      if (this.platform.ANDROID) {
        return AppProductTypeEnum.Android;
      } else if (this.platform.IOS) {
        return AppProductTypeEnum.iOS;
      }
    }
    // default web
    return AppProductTypeEnum.Web;

  }

}
